import * as React from 'react';
import { useContext } from 'react';
import { Appointments } from '@devexpress/dx-react-scheduler-material-ui';
import { SchedulerContext } from '../../SchedulerContext';
import { useIsExtraSmallScreen } from '../../../../../../../../Hooks/useFullscreenView';
import { getWeekDay } from '../../../../../../../../Utils/dateUtils';
import { tryStrToDateTime } from '../../../../../../../../Utils/stringUtils';
import { IBookingType } from './AppointmentComponent';

export interface IAppointmentContainer extends Appointments.ContainerProps {
  children: React.ReactElement<{
    params: { data: IBookingType };
  }>[];
}

export const AppointmentContainer = (props: IAppointmentContainer) => {
  const schedulerContext = useContext(SchedulerContext);
  const isExtraSmallScreen = useIsExtraSmallScreen();

  if (
    schedulerContext.currentViewName === 'Month' ||
    props.children[0].props.params.data.dayName
  ) {
    const startDate = new Date(
      String(props.children[0].props.params.data.startDate)
    );
    const endDate = new Date(
      String(props.children[0].props.params.data.endDate)
    );
    const mooreBookings = Boolean(
      props.children[0].props.params.data.mooreBookings
    );

    startDate.setHours(0, 0, 0);
    endDate.setHours(0, 0, 0);
    let oldYpos = Number(
      String(props.style.transform)
        .replace('translateY(', '')
        .replace('px)', '')
    );
    let newStyle,
      baseYposChange = schedulerContext.overView && isExtraSmallScreen ? 20 : 1,
      baseHeightChange = 1;

    if (
      schedulerContext.appointmentLimitMonthView[startDate.toDateString()] <= 0
    ) {
      if (!schedulerContext.dayScaleRecordMonthView[startDate.toDateString()]) {
        schedulerContext.overView
          ? (newStyle = {
              ...props.style,
              transform: `translateY(${
                oldYpos - (baseYposChange + baseHeightChange)
              }px)`,
              height: props.style.height - baseHeightChange,
            })
          : (newStyle = {
              ...props.style,
              transform: `translateY(${
                oldYpos - (baseYposChange + baseHeightChange)
              }px)`,
              height: props.style.height - baseHeightChange,
              width: '14%',
            });
      } else {
        mooreBookings
          ? (newStyle = {
              ...props.style,
              transform: `translateY(${oldYpos - baseYposChange}px)`,
              height: props.style.height - baseHeightChange,
              width: '2%',
            })
          : schedulerContext.overView
          ? (newStyle = {
              ...props.style,
              transform: `translateY(${oldYpos - baseYposChange}px)`,
              height: props.style.height - baseHeightChange,
            })
          : (newStyle = {
              ...props.style,
              transform: `translateY(${oldYpos - baseYposChange}px)`,
              height: props.style.height - baseHeightChange,
              width: '14%',
            });
      }
      Object.keys(schedulerContext.dayScaleRecordMonthView).forEach(element => {
        let limitedDate = new Date(element);
        if (limitedDate >= startDate && limitedDate <= endDate) {
          schedulerContext.dayScaleRecordMonthView[limitedDate.toDateString()] =
            !schedulerContext.dayScaleRecordMonthView[
              limitedDate.toDateString()
            ];
        }
      });
    } else {
      newStyle = {
        ...props.style,
        transform: `translateY(${oldYpos - baseYposChange}px)`,
      };
    }
    const newProps = { ...props, style: newStyle };
    return <div {...newProps}></div>;
  }

  const days = schedulerContext.currentViewName === 'Week' ? 7 : 1;
  const delta = schedulerContext.overView
    ? 100 / (Math.max(1, schedulerContext.resources.length) * days)
    : 100 / days;

  const startDate =
    tryStrToDateTime(props.children[0].props.params.data.startDate) ??
    new Date();
  const endDate =
    tryStrToDateTime(props.children[0].props.params.data.endDate) ?? new Date();

  //↓↓ Calculate the start offset
  const startOffset =
    schedulerContext.currentViewName === 'Week' ? getWeekDay(startDate) : 0;

  //↓↓ Calculate duration in days
  const durationInDays =
    schedulerContext.currentViewName === 'Week'
      ? Math.min(
          7 - startOffset,
          Math.ceil(
            (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
          )
        )
      : 1;

  const overViewOffset = schedulerContext.overView
    ? (100 / Math.max(1, schedulerContext.resources.length)) *
      (schedulerContext.resources.findIndex(
        res =>
          res.resName ===
          props.children[0].props.params.data.resourceNameList[0]
      ) ?? 0)
    : 0;

  const groupOffset: number =
    props.children[0].props.params.data.groupOffset ?? 0;
  const groupWidth: number =
    props.children[0].props.params.data.groupWidth ?? 1;
  const newProps = {
    ...props,
    style: {
      ...props.style,
      left: `${
        overViewOffset +
        delta * startOffset +
        groupOffset * (delta / groupWidth)
      }%`,
      width: `calc(${(delta * durationInDays) / groupWidth}% - 10px)`,
    },
  };

  return <Appointments.Container {...newProps}></Appointments.Container>;
};
